import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styletron-react';
import { sizes } from '../../const/sizes';
import { illustrationMap } from './constants';
const StyledIllustration = styled('img', ({ $size }) => ({
    width: $size,
    height: $size,
}));
export const Illustration = ({ name, size = 'medium' }) => {
    const sizeValue = sizes.illustration[size];
    return _jsx(StyledIllustration, { src: illustrationMap[name], $size: sizeValue });
};
